import { render, staticRenderFns } from "./ColumnCard.vue?vue&type=template&id=231762fc&"
import script from "./ColumnCard.vue?vue&type=script&lang=js&"
export * from "./ColumnCard.vue?vue&type=script&lang=js&"
import style0 from "./ColumnCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports